import CheckoutPageLayout from './CheckoutPageLayout';
import CheckoutErrorImage from '../images/checkout-error.svg';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';

interface CheckoutSuccessPageProps {
  onGoBack: () => void;
  onGoBackToPlanOptions: () => void;
}

const CheckoutErrorPage = ({
  onGoBack,
  onGoBackToPlanOptions,
}: CheckoutSuccessPageProps) => {
  return (
    <CheckoutPageLayout onGoBack={onGoBack}>
      <div className="flex flex-1 flex-col items-center justify-center">
        <img
          src={CheckoutErrorImage}
          alt="Checkout Error"
          className="w-[103px] h-auto mb-4"
        />

        <div className="flex flex-col gap-1 text-center mb-8">
          <Text variant="smallSubheader" className="text-black">
            Oops, it looks like something went wrong
          </Text>
          <Text variant="body" className="text-gray-600">
            Your order could not be completed.
          </Text>
        </div>

        <Button
          variant="primary"
          size="medium"
          className="bg-blue-600 text-white"
          onPress={onGoBackToPlanOptions}
        >
          Go back to Plan Options
        </Button>
      </div>
    </CheckoutPageLayout>
  );
};

export default CheckoutErrorPage;
